var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-delivery-tabs"},_vm._l((_vm.tabMappings),function(tab){return _c('b-button',{key:tab.key,class:{ active: tab.key == _vm.activeTab },attrs:{"variant":"light","value":tab.key,"disabled":tab.isDisabled || _vm.isLoading},on:{"click":_vm.handleClickTab}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }